<template>
  <Navbar />
  <div class="verify-email">
    <p>此頁面已棄用，請使用手機簡訊驗證。</p>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import Navbar from "../components/Navbar.vue";

const router = useRouter();

// 2026-08-06：verify-email 改為重導頁
//   - 已登入 → /bind-mobile（強制補綁手機）
//   - 未登入 → /phone-validate（註冊流程的簡訊驗證）
onMounted(() => {
  const token = localStorage.getItem("ms_platform_token");
  if (token) {
    router.replace("/bind-mobile");
  } else {
    router.replace("/phone-validate");
  }
});
</script>

<style scoped>
.verify-email {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
}
</style>
